import React, { PureComponent } from 'react'
import './styles.scss'
import PropTypes from 'prop-types'

class Alert extends PureComponent {
  render () {
    return (
      <div className={'alert alert-' + this.props.type}>{this.props.children}</div>
    )
  }
}

Alert.propTypes = {
  type: PropTypes.oneOf(['danger', 'success', 'warning', 'info']).isRequired
}

export default Alert
